module.exports = __webpack_public_path__ + "img/aboutCYT2.8a029362.jpg";